<template>
  <div class="inventory-form-page inventory-form-page--add">

    <!-- Header Card -->
        <PageHeader icon="fas fa-box-open">
      <template #title>
        Tambah Inventori
      </template>
      <template #subtitle>
        Tambahkan identitas, klasifikasi, dan informasi aset baru
      </template>
    </PageHeader>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :card-class="'inventory-form-card'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'inventories'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/inventory/InventoryForm.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
          photo: '/images/default-medicine.svg',
          inventory_status_id: 1
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inventory", route: "" },
      { title: "Daftar Inventory", route: "/inventory/list" },
      { title: "Tambah" },
    ])
  },

}

</script>
<style lang="scss" src="@/assets/sass/pages/_inventory-form-page.scss"></style>
